interface FooterCopyrightProps {
  copyright?: string
}

const FooterCopyright = ({ copyright }: FooterCopyrightProps) => {
  if (!copyright) {
    return null
  }

  return (
    <div className="flex justify-start items-center mt-20">
      <p className="text-center text-sm">{copyright}</p>
    </div>
  )
}

export default FooterCopyright
